<template lang="pug">
#dashboard-operacao
    BaseHeader(
        :titulo="$t('mensagens.operacao.dashboard.titulo')",
        icon='el-icon-download',
        iconBotaoSecundario='el-icon-download',
        :btnTexto="$t('mensagens.operacao.dashboard.botaoAlertaNaoInibidos')",
        :btnTextoSecundario="$t('mensagens.operacao.dashboard.botaoAlertaInibidos')",
        :btnTextoTerciario="$t('mensagens.operacao.dashboard.botaoExportar')",
        :exibeBotao='true',
        :exibeBotaoSecundario='true',
        :exibeBotaoTerciario='true',
        :desabilitaBotao='this.loadingPlanilha'
        :loading='this.loadingPlanilha'
        @btnHeaderClicado='exportarAlertasNaoInibidos()'
        @btnHeaderClicadoSecundario='exportarAlertasInibidos()',
        @btnHeaderClicadoTerciario='exportarInformacoes()'

    )

    .view-container-base-header
        CardFiltrosDashBoardOperacao.mb-4(@filtrar='filtrar')

        SessaoIndicadoresDashboardOperacao.mb-4(
            :payload='sessaoIndicadores.payload',
            :loading='sessaoIndicadores.loading',
            :erro='sessaoIndicadores.erro'
        )

        CardPercentualAlertasDashboardOperacao.mb-4(
            :titulo='sessaoPercentualAlertasPorCriterio.titulo'
            :payload='sessaoPercentualAlertasPorCriterio.payload',
            :loading='sessaoPercentualAlertasPorCriterio.loading',
            :erro='sessaoPercentualAlertasPorCriterio.erro'
        )

        CardTotalizadoresDashboardOperacao(
            :payload='sessaoTotalizadores.payload',
            :dados-grafico='sessaoTotalizadores.dadosGrafico',
            :dados-tabela='sessaoTotalizadores.dadosTabela',
            :loading='sessaoTotalizadores.loading',
            :erro='sessaoTotalizadores.erro',
            @atualizarGraficoTotalizadores='buscarDadosGraficoTotalizadores',
            @atualizarTabelaTotalizadores='buscarDadosTabelaTotalizadores',
            ref='cardTotalizadoresDashboardOperacaoRefs'
        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import SessaoIndicadoresDashboardOperacao from '@/components/operacao/dashboard/SessaoIndicadoresDashboardOperacao.vue';
import OperacaoDashboardService from '@/services/OperacaoDashboardService';
import FileGenerationUtils from '@/utils/FileGenerationUtils';
import CardPercentualAlertasDashboardOperacao from '@/components/operacao/dashboard/CardPercentualAlertasDashboardOperacao.vue';
import CardFiltrosDashBoardOperacao from '@/components/operacao/dashboard/CardFiltrosDashBoardOperacao.vue';
import CardTotalizadoresDashboardOperacao from '@/components/operacao/dashboard/CardTotalizadoresDashboardOperacao.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'index',
    components: {
        BaseHeader,
        CardPercentualAlertasDashboardOperacao,
        CardFiltrosDashBoardOperacao,
        CardTotalizadoresDashboardOperacao,
        SessaoIndicadoresDashboardOperacao
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    data: () => ({
        codigoTotalizadorSelecionado: null,

        sessaoIndicadores: {
            loading: false,
            erro: false,
            payload: []
        },

        sessaoPercentualAlertasPorCriterio: {
            loading: false,
            erro: false,
            titulo: 'Porcentagem',
            payload: []
        },

        sessaoTotalizadores: {
            loading: false,
            erro: false,
            payload: [],
            dadosGrafico: {
                loading: false,
                erro: false,
                payload: []
            },
            dadosTabela: {
                loading: false,
                erro: false,
                payload: null
            }
        },

        filtros: {
            idsEmpresas: [],
            idsCategorias: [],
            dataCadastroInicio: null,
            dataCadastroFim: null,
            dataVigenciaInicio: null,
            dataVigenciaFim: null
        },

        loadingPlanilha: false
    }),

    async mounted() {
        this.buscarIndicadores();
        this.buscarPercentualAlertas();
        this.buscarTotalizadores();
    },

    watch: {
        '$i18n.locale': function (newLocale) {
            this.buscarIndicadores();
            this.buscarPercentualAlertas();
            this.buscarTotalizadores();
        }
    },

    methods: {
        async buscarIndicadores() {
            this.sessaoIndicadores.loading = true;

            await OperacaoDashboardService.buscarIndicadores(this.filtros)
                .then(({ data }) => {
                    let dataInicial = data;
                    const indicadoresCodigoMap = {
                        'Percentual de reprovação': 'PERCENTUAL_REPROVACAO',
                        'Percentual de alertas': 'PERCENTUAL_ALERTAS',
                        'Percentual de tratamento': 'PERCENTUAL_TRATAMENTO',
                        'Percentual de irregularidades': 'PERCENTUAL_IRREGULAR'
                    };

                    const indicadoresCodigo = dataInicial.indicadores.map(indicador => {
                        const codigo = indicadoresCodigoMap[indicador.descricao];
                        const tooltip = this.traduzirTooltipIndicador(indicador.tooltip);
                        return {
                            ...indicador,
                            codigo: codigo,
                            tooltip: tooltip
                        };
                    });

                    this.sessaoIndicadores.payload = indicadoresCodigo;
                    this.sessaoIndicadores.erro = false;
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.idsErroBusca')
                    });
                    this.sessaoIndicadores.erro = true;
                })
                .finally(() => {
                    this.sessaoIndicadores.loading = false;
                });
        },

        async buscarPercentualAlertas() {
            this.sessaoPercentualAlertasPorCriterio.loading = true;

            await OperacaoDashboardService.buscarGraficoRestricoes(this.filtros)
                .then(({ data }) => {
                    let itens = [];

                    if (data.itens.length > 0) {
                        itens = [
                            [
                                this.$t('mensagens.operacao.dashboard.camada'),
                                this.$t('mensagens.operacao.monitoramento.percentual'),
                                {
                                    type: 'string',
                                    role: 'tooltip',
                                    p: { html: true }
                                }
                            ]
                        ];

                        data.itens.forEach(
                            ({
                                codigoCamada,
                                percentual,
                                percentualFormatado,
                                qdeOperacoes,
                                area
                            }) => {
                                const camadaTraduzida = this.$t(`mensagens.camadas.${codigoCamada}`);
                                itens.push([
                                    camadaTraduzida,
                                    percentual,
                                    this.gerarTooltipPercentualAlertas(
                                        camadaTraduzida,
                                        percentual,
                                        percentualFormatado,
                                        qdeOperacoes,
                                        area
                                    )
                                ]);
                            }
                        );
                    }
                    let titulo = this.$t('mensagens.operacao.dashboard.porcentagem');
                    this.sessaoPercentualAlertasPorCriterio.titulo = titulo;
                    this.sessaoPercentualAlertasPorCriterio.payload = itens;
                    this.sessaoPercentualAlertasPorCriterio.erro = false;
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            this.$t('mensagens.operacao.notificacao.erroPercentualAlerta')
                    });
                    this.sessaoPercentualAlertasPorCriterio.erro = true;
                })
                .finally(() => {
                    this.sessaoPercentualAlertasPorCriterio.loading = false;
                });
        },

        async buscarTotalizadores() {
            this.sessaoTotalizadores.loading = true;
            if (
                this.$refs.cardTotalizadoresDashboardOperacaoRefs.mostrarGrafico
            ) {
                this.sessaoTotalizadores.dadosGrafico.loading = true;
            } else {
                this.sessaoTotalizadores.dadosTabela.loading = true;
            }

            await OperacaoDashboardService.buscarTotalizadores(this.filtros)
                .then(({ data }) => {
                    if (data.totalizadores.length > 0) {
                        this.sessaoTotalizadores.payload =
                            data.totalizadores.map(camada => ({
                                ...camada,
                                descricao: this.traduzirDescricao(camada.descricao),
                                selecionado: false
                            }));
                        this.sessaoTotalizadores.payload[0].selecionado = true;
                        this.sessaoTotalizadores.erro = false;
                        if (
                            this.$refs.cardTotalizadoresDashboardOperacaoRefs
                                .mostrarGrafico
                        ) {
                            this.buscarDadosGraficoTotalizadores(
                                this.sessaoTotalizadores.payload[0].codigo
                            );
                        } else {
                            this.buscarDadosTabelaTotalizadores(
                                this.sessaoTotalizadores.payload[0].codigo
                            );
                        }
                        this.$refs.cardTotalizadoresDashboardOperacaoRefs.codigoTotalizadorSelecionado =
                            this.sessaoTotalizadores.payload[0].codigo;
                        this.$refs.cardTotalizadoresDashboardOperacaoRefs.opcaoGrafico.title = `${this.$t('mensagens.operacao.dashboard.totalizadorSelecionado')}: ${this.$t(`mensagens.operacao.dashboard.totalizador.${this.sessaoTotalizadores.payload[0].codigo}`)}`;
                    } else {
                        this.sessaoTotalizadores.erro = true;
                        if (
                            this.$refs.cardTotalizadoresDashboardOperacaoRefs
                                .mostrarGrafico
                        ) {
                            this.sessaoTotalizadores.dadosGrafico.erro = true;
                        } else {
                            this.sessaoTotalizadores.dadosTabela.erro = true;
                        }
                    }
                })
                .catch(() => {
                    this.$notify.error({
                        message: this.$t('mensagens.operacao.notificacao.totalizadoresErroBusca')
                    });
                    this.sessaoTotalizadores.erro = true;
                    if (
                        this.$refs.cardTotalizadoresDashboardOperacaoRefs
                            .mostrarGrafico
                    ) {
                        this.sessaoTotalizadores.dadosGrafico.erro = true;
                    } else {
                        this.sessaoTotalizadores.dadosTabela.erro = true;
                    }
                })
                .finally(() => {
                    this.sessaoTotalizadores.loading = false;
                });
        },

        async buscarDadosTabelaTotalizadores(codigoTotalizadorSelecionado) {
            this.sessaoTotalizadores.dadosTabela.loading = true;

            await OperacaoDashboardService.buscarTabelaTotalizadores({
                idsEmpresas: this.filtros.idsEmpresas,
                codigo: codigoTotalizadorSelecionado,
                idsCategorias: this.filtros.idsCategorias
            })
                .then(({ data }) => {
                    let dataInicial = data;
                    const colunaCodigoMap = {
                        'Data cadastro': 'DATA_CADASTRO',
                        'Nome': 'NOME',
                        'Localidade': 'LOCALIDADE',
                        'Área': 'AREA',
                        'Nº restrições': 'NUMERO_RESTRICOES',
                        'Nº operações vinculadas': 'OPERACOES_VINCULADAS',
                        'Documento': 'DOCUMENTO',
                        'E-mail': 'EMAIL',
                        'Id Cliente': 'ID_CLIENTE',
                        'Identificador': 'IDENTIFICADOR',
                        'Categoria': 'CATEGORIA',
                        'Situação': 'SITUACAO',
                        'Possui alerta': 'POSSUI_ALERTA',
                        'Motivo da reprovação': 'MOTIVO_REPROVACAO',
                        'Critério': 'CRITERIO',
                        'Tipo de vínculo': 'TIPO_VINCULO',
                        'Vínculo': 'VINCULO',
                        'Nº operações impactadas': 'OPERACOES_IMPACTADAS',
                        'Motivo da inibição': 'MOTIVO_INIBICAO',
                        'Beneficiário': 'BENEFICIARIO',
                        'Status': 'STATUS'
                    };

                    const colunaCodigo = dataInicial.colunas.map(coluna => {
                        const codigo = colunaCodigoMap[coluna];
                        return {
                            ...coluna,
                            codigo: codigo
                        };
                    });

                    dataInicial.colunas = colunaCodigo;
                    this.sessaoTotalizadores.dadosTabela.payload = dataInicial;
                    this.sessaoTotalizadores.dadosTabela.erro = false;
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            this.$t('mensagens.operacao.notificacao.totalizadorDadoTabelaErro')
                    });
                    this.sessaoTotalizadores.dadosTabela.erro = true;
                    this.sessaoTotalizadores.dadosTabela.payload = null;
                })
                .finally(() => {
                    this.sessaoTotalizadores.dadosTabela.loading = false;
                });
        },

        async buscarDadosGraficoTotalizadores(codigoTotalizadorSelecionado) {
            this.sessaoTotalizadores.dadosGrafico.loading = true;

            await OperacaoDashboardService.buscarGraficoTotalizadores({
                idsEmpresas: this.filtros.idsEmpresas,
                codigo: codigoTotalizadorSelecionado,
                idsCategorias: this.filtros.idsCategorias
            })
                .then(({ data }) => {
                    let itens = [];

                    if (data.itens.length > 0) {
                        itens = [
                            [
                                {
                                    label: this.$t('mensagens.operacao.dashboard.mes'),
                                    type: 'string'
                                },
                                {
                                    label: this.$t('mensagens.operacao.dashboard.total'),
                                    type: 'number'
                                },
                                {
                                    type: 'string',
                                    role: 'tooltip',
                                    p: { html: true }
                                }
                            ]
                        ];

                        data.itens.forEach(({ total, mes, descricao, descricaoTotal }) => {
                            const mesTraduzido = this.traduzirMes(mes);
                            const descricaoTraduzida = this.traduzirDescricao(descricao);
                            const [numeroDescricaoTotal, textoDescricaoTotal] = descricaoTotal.split(/([^\d.]+)/).filter(Boolean);
                            let mensagemDescricaoTotal = '';
                            switch (textoDescricaoTotal.trim().toLowerCase()) {
                                case 'território(s)':
                                    mensagemDescricaoTotal = this.$t('mensagens.operacao.dashboard.territorios');
                                    break;
                                case 'pessoa(s)':
                                    mensagemDescricaoTotal = this.$t('mensagens.operacao.dashboard.pessoas');
                                    break;
                                case 'área':
                                    mensagemDescricaoTotal = this.$t('mensagens.operacao.dashboard.area');
                                    break;
                                case 'operação(ões)':
                                    mensagemDescricaoTotal = this.$t('mensagens.operacao.dashboard.operacoes');
                                    break;
                                case 'restrição(ões)':
                                    mensagemDescricaoTotal = this.$t('mensagens.operacao.dashboard.restricoes');
                                    break;
                            }
                            descricaoTotal = `${numeroDescricaoTotal} ${mensagemDescricaoTotal}`;

                            itens.push([
                                mesTraduzido,
                                total,
                                this.gerarTooltipGraficoTotalizadores(mesTraduzido, descricaoTraduzida, descricaoTotal)
                            ]);
                            }
                        );
                    }

                    this.sessaoTotalizadores.dadosGrafico.payload = itens;
                    this.sessaoTotalizadores.dadosGrafico.erro = false;
                })
                .catch(() => {
                    this.$notify.error({
                        message:
                            this.$t('mensagens.operacao.notificacao.totalizadorGraficoErro')
                    });
                    this.sessaoTotalizadores.dadosGrafico.erro = true;
                })
                .finally(() => {
                    this.sessaoTotalizadores.dadosGrafico.loading = false;
                });
        },

        exportarInformacoes() {
            FileGenerationUtils.cadastrarArquivoFilaProcessamento(this, 'PLANILHA_OPERACAO_DASHBOARD', {dashboardInputFilter: this.filtros});
        },

        exportarAlertasInibidos() {
            FileGenerationUtils.cadastrarArquivoFilaProcessamento(this, 'PLANILHA_OPERACAO_ALERTAS_INIBIDOS', {dashboardInputFilter: this.filtros});
        },

        exportarAlertasNaoInibidos() {
            FileGenerationUtils.cadastrarArquivoFilaProcessamento(this, 'PLANILHA_OPERACAO_ALERTAS_NAO_INIBIDOS', {dashboardInputFilter: this.filtros});
        },

        gerarTooltipPercentualAlertas(
            camada,
            percentual,
            percentualFormatado,
            qdeOperacoes,
            area
        ) {
            return (
                '<section id="tooltip-graficos">' +
                '       <div>' +
                camada +
                ' | ' +
                percentualFormatado +
                '</div>' +
                '       <div>' +
                qdeOperacoes +
                ' ' + this.$t('mensagens.operacao.tabela.rodapePaginacao') + ' | ' +
                area +
                '</div>' +
                '</section>'
            );
        },

        gerarTooltipGraficoTotalizadores(mes, descricao, descricaoTotal) {
            return (
                '<section id="tooltip-graficos">' +
                '       <div>' +
                descricao +
                ' | ' +
                mes +
                '</div>' +
                '       <div>' +
                descricaoTotal +
                '</div>' +
                '</section>'
            );
        },

        filtrar(filtro) {
            this.sessaoTotalizadores.dadosGrafico.payload = null;
            this.sessaoTotalizadores.dadosTabela.payload = null;

            this.filtros = filtro;

            this.buscarIndicadores();
            this.buscarPercentualAlertas();
            this.buscarTotalizadores();
        },

        traduzirDescricao(descricao) {
            switch (descricao) {
                case 'Territórios cadastrados':
                    return this.$t('mensagens.operacao.dashboard.totalizador.TERRITORIOS_CADASTRADOS');
                case 'Territórios em monitoramento':
                    return this.$t('mensagens.operacao.dashboard.totalizador.TERRITORIOS_MONITORADOS');
                case 'Área em monitoramento RSA (ha)':
                    return this.$t('mensagens.operacao.dashboard.totalizador.AREA_MONITORADA');
                case 'Territórios com restrição':
                    return this.$t('mensagens.operacao.dashboard.totalizador.TERRITORIOS_RESTRICAO');
                case 'Pessoas cadastradas':
                    return this.$t('mensagens.operacao.dashboard.totalizador.PESSOAS_CADASTRADAS');
                case 'Pessoas em monitoramento':
                    return this.$t('mensagens.operacao.dashboard.totalizador.PESSOAS_MONITORADAS');
                case 'Pessoas com restrição':
                    return this.$t('mensagens.operacao.dashboard.totalizador.PESSOAS_RESTRICAO');
                case 'Operações cadastradas':
                    return this.$t('mensagens.operacao.dashboard.totalizador.OPERACOES_CADASTRADAS');
                case 'Operações aprovadas em monitoramento':
                    return this.$t('mensagens.operacao.dashboard.totalizador.OPERACOES_MONITORADAS');
                case 'Operações reprovadas':
                    return this.$t('mensagens.operacao.dashboard.totalizador.OPERACOES_REPROVADAS');
                case 'Operações com alerta':
                    return this.$t('mensagens.operacao.dashboard.totalizador.OPERACOES_ALERTA');
                case 'Número de restrições':
                    return this.$t('mensagens.operacao.dashboard.totalizador.RESTRICOES');
                case 'Restrições inibidas':
                    return this.$t('mensagens.operacao.dashboard.totalizador.RESTRICOES_INIBIDAS');
                case 'Operações relacionadas às inibições':
                    return this.$t('mensagens.operacao.dashboard.totalizador.OPERACOES_RELACIONADAS_INIBICAO');
                case 'Operações fiscalizadas':
                    return this.$t('mensagens.operacao.dashboard.totalizador.OPERACOES_FISCALIZADAS');
                case 'Operações irregulares':
                    return this.$t('mensagens.operacao.dashboard.totalizador.OPERACOES_IRREGULARES');
            }
        },

        traduzirMes(mesAno) {
            const partes = mesAno.split('/');
            const mes = partes[0];
            const ano = partes[1];

            let mesTraduzido;
            switch (mes) {
                case 'JAN':
                    mesTraduzido = this.$t('mensagens.operacao.dashboard.meses.janeiro');
                    break;
                case 'FEV':
                    mesTraduzido = this.$t('mensagens.operacao.dashboard.meses.fevereiro');
                    break;
                case 'MAR':
                    mesTraduzido = this.$t('mensagens.operacao.dashboard.meses.marco');
                    break;
                case 'ABR':
                    mesTraduzido = this.$t('mensagens.operacao.dashboard.meses.abril');
                    break;
                case 'MAI':
                    mesTraduzido = this.$t('mensagens.operacao.dashboard.meses.maio');
                    break;
                case 'JUN':
                    mesTraduzido = this.$t('mensagens.operacao.dashboard.meses.junho');
                    break;
                case 'JUL':
                    mesTraduzido = this.$t('mensagens.operacao.dashboard.meses.julho');
                    break;
                case 'AGO':
                    mesTraduzido = this.$t('mensagens.operacao.dashboard.meses.agosto');
                    break;
                case 'SET':
                    mesTraduzido = this.$t('mensagens.operacao.dashboard.meses.setembro');
                    break;
                case 'OUT':
                    mesTraduzido = this.$t('mensagens.operacao.dashboard.meses.outubro');
                    break;
                case 'NOV':
                    mesTraduzido = this.$t('mensagens.operacao.dashboard.meses.novembro');
                    break;
                case 'DEZ':
                    mesTraduzido = this.$t('mensagens.operacao.dashboard.meses.dezembro');
                    break;
            }
            const resultado = mesTraduzido + '/' + ano;
            return resultado;
        },

        traduzirTooltipIndicador(tooltip) {
            switch (tooltip) {
                case 'Fórmula: total de operações reprovadas / total de operações cadastradas':
                    return this.$t('mensagens.operacao.dashboard.tooltipOperacoes1');
                case 'Fórmula: total de operações com alerta / total de operações aprovadas':
                    return this.$t('mensagens.operacao.dashboard.tooltipOperacoes2');
                case 'Fórmula: total de restrições inibidas / total de restrições':
                    return this.$t('mensagens.operacao.dashboard.tooltipOperacoes3');
                case 'Fórmula: total de laudos de fiscalização com status inconforme / total de operações fiscalizadas':
                    return this.$t('mensagens.operacao.dashboard.tooltipOperacoes4');
            }
        }
    }
};
</script>

<style lang="scss">
.el-dropdown-menu.el-popper {
    z-index: 4000 !important;
}
.el-notification__content {
    white-space: pre-line;
    text-align:left !important;
}

#dashboard-operacao {
    height: 100%;
    width: 100%;

    #tooltip-graficos {
        background: #3f3f3f;
        color: white;
        padding: 5px;
        border-radius: 5px;
        min-width: 160px;
        text-align: center;
    }

}
</style>
